module.exports = __webpack_public_path__ + "img/kraken.933a30cc.jpg";